import appConstants from "../../../constants";

export function selectFilterValue(filterValue, filterValues) {
//  if (!filterValue[appConstants.KEY_IS_DISABLED] && !filterValue[appConstants.KEY_IS_SELECTED]) {
    return {
      areFilterValuesUpdated: true,
      updatedFilterValues: filterValues.map(
        (fv) => {
          if (
            (fv[appConstants.KEY_CODE] === filterValue[appConstants.KEY_CODE]) //||  // newly selected value
            //(fv[appConstants.KEY_IS_SELECTED]) // previously selected value
          ) {
            let newFilterValue = { ...fv };
            newFilterValue[appConstants.KEY_IS_SELECTED] = true; //!fv[appConstants.KEY_IS_SELECTED];
            return newFilterValue;
          }
          else {
            if (fv[appConstants.KEY_IS_SELECTED]) {
              let previouslySelectedFV = { ...fv };
              previouslySelectedFV[appConstants.KEY_IS_SELECTED] = false;
              return previouslySelectedFV;
            }
            else {
              return fv;
            }
          }
        }
      )
    }
//  }
//  return { areFilterValuesUpdated: false };
}

export function unselectFilterValue(filterValue, filterValues) {
//  if (!filterValue[appConstants.KEY_IS_DISABLED] && filterValue[appConstants.KEY_IS_SELECTED]) {
    return {
      areFilterValuesUpdated: true,
      updatedFilterValues: filterValues.map(
        (fv) => {
          if (fv[appConstants.KEY_CODE] === filterValue[appConstants.KEY_CODE]) {
            let newFilterValue = { ...fv };
            newFilterValue[appConstants.KEY_IS_SELECTED] = false; //!fv[appConstants.KEY_IS_SELECTED];
            return newFilterValue;
          }
          else {
            return fv;
          }
        }
      )
    }
//  }
//  return { areFilterValuesUpdated: false };
}

export function toggleFilterValue(filterValue, filterValues) {
  if (!filterValue[appConstants.KEY_IS_DISABLED]) {
    let selectedCount = 0;
    return {
      areFilterValuesUpdated: true,
      updatedFilterValues: filterValues.map(
        (fv) => {

          if (fv[appConstants.KEY_CODE] === filterValue[appConstants.KEY_CODE]) {
            let newFilterValue = { ...fv };
            newFilterValue[appConstants.KEY_IS_SELECTED] = !fv[appConstants.KEY_IS_SELECTED];
            if(newFilterValue[appConstants.KEY_IS_SELECTED]) { selectedCount++; }
            return newFilterValue;
          }
          else {
            if(fv[appConstants.KEY_IS_SELECTED]) { selectedCount++; }
            return fv;
          }
        }
      ),
      selectedFilterValueCount: selectedCount
    }
  }
  return { areFilterValuesUpdated: false };
}

export function selectAllFilterValues(filterValues) {
  return filterValues.map((filterValue) => {
//    if (!filterValue[appConstants.KEY_IS_DISABLED] && !filterValue[appConstants.KEY_IS_SELECTED]) {
      let newFilterValue = { ...filterValue };
      newFilterValue[appConstants.KEY_IS_SELECTED] = true;
      return newFilterValue;
//    }
//    else {
//      return filterValue;
//    }
  });
}



